<script setup lang="ts" generic="T extends { message?: string }">
defineProps<{ result: FormResult<T> }>();
defineEmits<{ submit: [event: Event]; reset: [] }>();
const instance = getCurrentInstance();
const showReset = computed(() => instance?.vnode.props?.onReset);
</script>

<template>
  <div class="form-wrapper">
    <template v-if="result.status === 'error'">
      <slot name="error" :show-reset="showReset">
        <div class="message prose">
          <p class="text-danger" v-html="result.message" />
          <button v-if="showReset" type="button" class="link-prose" @click="$emit('reset')">
            Essayer à nouveau
          </button>
        </div>
      </slot>
    </template>
    <template v-else-if="result.status === 'success'">
      <slot name="success" :show-reset="showReset" :data="result.data">
        <div class="message prose">
          <p class="text-success" v-html="result.data.message || 'Le formulaire a été soumis avec succès.'" />
          <button v-if="showReset" type="button" class="link-prose" @click="$emit('reset')">
            Ok
          </button>
        </div>
      </slot>
    </template>
    <form v-else class="space-y-4" novalidate @submit="(e) => $emit('submit', e)">
      <slot />
    </form>
  </div>
</template>
